export default {
    loading: 'monitor:operating:loading',
    search: 'monitor:operating:search',
    logs: 'monitor:operating:logs',
}


// WEBPACK FOOTER //
// ./pages/monitor/operating/constant.js